export interface GTMEventDetails {
  GA_event_category?: string;
  GA_event_action?: string;
  GA_event_label?: string;
  GA_event_detail?: string;
  event: string;
  GA_funnel_origen?: string;
  [key: string]: any;
}

export const sendGTMEvent = (eventObject: GTMEventDetails) => {
  if (process.env.REACT_APP_ENV === 'production' && window?.dataLayer) {
    if (eventObject.event === 'purchase') {
      window.dataLayer.push({ ecommerce: null });
    }
    window.dataLayer.push(eventObject);
    return;
  }

  if (process.env.REACT_APP_ENV !== 'production') {
    console.log('[sendGTMEvent]', eventObject);
  }
};
